export const GOOGLE_TILE_SESSION_RETRY = {
  MAX_ATTEMPTS: 2,
  DELAY_MS: 1000,
} as const;
